import Vue from 'vue'
import VueResource from 'vue-resource'
import store from '../store'
import message from './msg_srv'
Vue.use(VueResource)

// api基础参数配置 Todo:修改配置的方式
const apiUrl = "http://api.5seer.cn/api";        //接口地址
const timestamp = (new Date()).getTime() / 1000;   //时间戳
const platformParams = {
    platform: 80,
    version: '1.3.5',
    time: timestamp
}
// 封装基础http请求方法
var getApi = function (url, params, sucCallback, failCallback) {
    var getUrl = apiUrl + url,
        pathName = window.location.pathname;
    var getParams = Object.assign(params, platformParams);

    if (url.indexOf('login') == -1) {
        // 非登录接口要添加用户信息参数
        //uid for test:::1014901
        getParams = Object.assign(getParams, {
            token: store.state.userData.token
            // isphper: 1014901
        })
    }

    Vue.http.get(getUrl, { params: getParams }, { emulateJSON: true }).then((response) => {

        switch (response.data.status_code) {
            case 200:
                if (sucCallback) {
                    sucCallback(response.data.data)
                }
                break;
            default:
                if (response.data.status_code) {
                    console.error("请求失败", message[response.data.status_code]);
                }
                if (failCallback) { failCallback(response.data) }
                break;
        }
    })
}

// 注册事件，方便调用
var API = {
    // 个人信息获取
    getUserInfo: function (params, suc_cb, fail_cb) { getApi('/user', params, suc_cb, fail_cb) },
    // 登录方法
    thirdLogin: function (params, suc_cb, fail_cb) { getApi('/login/thirdLogin', params, suc_cb, fail_cb) },
    // 添加测算
    addUser: function (params, suc_cb, fail_cb) { getApi('/cow/add', params, suc_cb, fail_cb) },
    // 领取免费资格
    setFree: function (params, suc_cb, fail_cb) { getApi('/cow/setFree', params, suc_cb, fail_cb) },
    // 免费解锁
    freeLock: function (params, suc_cb, fail_cb) { getApi('/cow/freeLock', params, suc_cb, fail_cb) },
    // 获取测算报告
    getUserHomePage: function (params, suc_cb, fail_cb) { getApi('/cow/getHomePage', params, suc_cb, fail_cb) },
    // 获取测算列表
    getReportList: function (params, suc_cb, fail_cb) { getApi('/cow/getList', params, suc_cb, fail_cb) },
	// 获取商品列表
	getProductList: function (params, suc_cb, fail_cb) { getApi('/pay/productList', params, suc_cb, fail_cb) },
	// 下单
	createPayOrder: function (params, suc_cb, fail_cb) { getApi('/pay/createOrder', params, suc_cb, fail_cb) },
    // 微信:微信授权
    getWeixinSdkConfig: function (params, suc_cb, fail_cb) { getApi('/muhuo/config/weixinSdk', params, suc_cb, fail_cb) },
}

export {
    API, message
}